module.exports = __webpack_public_path__ + "static/media/dashbord_icon.ce64b380.svg";